import type { Translator } from '@porotutu/i18n'
import type {
  FilterSelectSpec,
  FilterTextSpec,
} from '@porotutu/react/components/FilterBar/FilterBar'
import { EARNING_TRIGGERS, isFilteredBy } from '../../vocabulary'
import type { EarningRuleListQuery } from '../queries'

export const ACTIVE_CHOICES = ['true', 'false'] as const

export const filtersFor = (t: Translator, query: EarningRuleListQuery): FilterSelectSpec[] => [
  {
    name: 'trigger_type',
    label: t('crm.earning_rules.filters.trigger_type'),
    value: String(query.trigger_type ?? ''),
    options: EARNING_TRIGGERS.map((trigger) => ({
      value: trigger,
      label: t(`crm.earning_rules.trigger_type.${trigger}`),
    })),
  },
  {
    name: 'active',
    label: t('crm.earning_rules.filters.active'),
    value: String(query.active ?? ''),
    options: ACTIVE_CHOICES.map((choice) => ({
      value: choice,
      label: t(`crm.earning_rules.active.${choice}`),
    })),
  },
]

export const textsFor = (t: Translator, query: EarningRuleListQuery): FilterTextSpec[] => [
  {
    name: 'campaign_id',
    label: t('crm.earning_rules.filters.campaign_id'),
    value: String(query.campaign_id ?? ''),
    placeholder: t('crm.earning_rules.filters.campaign_id'),
  },
]

export const isFiltered = (query: EarningRuleListQuery) =>
  isFilteredBy(query, ['search', 'campaign_id', 'trigger_type', 'active'])
